<template>
  <div class="set-task-verify">
    <div class="content-item">
      <div class="item-title">
        选择审批发起人
        <span class="require-flag">*</span>
      </div>
      <select-people
        ref="originator"
        v-model="originator"
        from="Project"
        :project-id="projectId"
        :people-group="peopleGroup"
        :data-range="['user']"
        class="mTop10"
      ></select-people>
    </div>
    <div class="content-item">
      <div class="item-title">
        选择审批人员
        <span class="require-flag">*</span>
      </div>
      <select-people
        ref="candidates"
        v-model="candidates"
        from="Project"
        :project-id="projectId"
        :people-group="peopleGroup"
        multiple
        class="mTop10"
      ></select-people>
    </div>
  </div>
</template>

<script>
import SelectPeople from "@/components/Workflow/SelectPeople"

export default {
  name: "set-task-verify",
  components: {
    SelectPeople
  },
  props: {
    flowInfo: Object,
    projectId: String,
    peopleGroup: Array
  },
  data() {
    return {
      originator: "",
      candidates: []
    }
  },
  methods: {
    init() {
      this.originator = this.flowInfo.data.originatorUserId
      this.candidates = this.flowInfo.data.candidates
    },
    output() {
      if (!this.originator?.length) return { result: false, msg: "未选择审批发起人！" }
      if (!this.candidates?.length) return { result: false, msg: "未选择审批人员！" }
      Object.assign(this.flowInfo.data, {
        originatorUserId: this.originator[0].code,
        candidates: this.candidates
      })
      !this.flowInfo.extra && (this.flowInfo.extra = {})
      Object.assign(this.flowInfo.extra, {
        originator: this.originator[0]?.label,
        candidates: this.candidates.reduce((acc, cur, index) => {
          if (index == 0) acc = cur.label + (cur.type === "superior" ? "上级" : "")
          else acc = acc + "，" + cur.label + (cur.type === "superior" ? "上级" : "")
          return acc
        }, ""),
        description: {
          originator: this.originator[0]?.label,
          candidates: this.candidates.reduce((acc, cur, index) => {
            if (index === 0) acc = cur.label + (cur.type === "superior" ? "上级" : "")
            else acc = acc + "，" + cur.label + (cur.type === "superior" ? "上级" : "")
            return acc
          }, "")
        }
      })
      return { result: true }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-item {
  .require-flag {
    color: red;
    font-size: 22px;
    position: relative;
    top: 3px;
  }
}
</style>
